export default __webpack_public_path__ + "static/blob3-4fc499e9d2da99c96ed5c5b04e5374cb.svg";